// work data

export const Work = [
    {
        id:1,
        name:"Quiz App",
        description:"It is build on top of the React JS, with Material-UI.",
        tags:["react","Material-UI", "Netlify"],
        
        demo:"https://mystartquiz.netlify.app/",
        github:"https://github.com/gamzeumac/startquiz"
    },
    {
        id:2,
        name:"Recipe",
        description:"A Recipe listing website build in ReactJS. With realtime fetching of articles from dev.to using API.",
        tags:["react","sass", "Github-Pages"],
        
        demo:"https://gamzeumac.github.io/api/",
        github:"https://github.com/gamzeumac/api"
        
    },
    { id:3,
        name:"Music Player",
        description:"A Music Player build using JS  ",
        tags:["JS","HTML","CSS"],
        
        demo:"https://gamzeumac.github.io/MusicPlayer/",
        github:"https://github.com/gamzeumac/MusicPlayer"
        

    }
    
   ,
    {
        id:4,
        name:"Restaurant Page",
        description:"A cool looking Restaurant build using JS and Html.",
        tags:["html","css","js"],
        
        demo:"https://myrestaurantpage.netlify.app/",
        github:"https://github.com/gamzeumac/myRestauranPagewithJS"
       
    },{
        id:5,
        name:"Todo App(Typescript + Redux)",
        description:"A todo app build using Redux-toolkit and Typescript for smooth animations.",
        tags:["react","redux","typescript"],
        
        demo:"https://todo-withtypescript.netlify.app/",
        github:"https://github.com/gamzeumac/todowithtypescript"
        
    },
    {
        id:6,
        name:"QR Scanner",
        description:"A responsive QR Scanner component in ReactJS with Material-Ui functionalities. Built from scratch.",
        tags:["react","Material-UI"],
        
        demo:"https://my-qr-scanner.netlify.app/",
        github:"https://github.com/gamzeumac/my_qr_scanner"
        
    },
    { id:7,
        name:"Todo App(VueJS + Bootstrap)",
        description:"A todo app build using VueJS(CLI) and Bootstrap for smooth animations.",
        tags:["VueJS","Bootstrap","typescript"],
        
        demo:"https://mytodowithvuejs.netlify.app/",
        github:"https://github.com/gamzeumac/Todo_with_VueJS"
        

    }, {
        id:8,
        name:"Music App",
        description:"A Music App build using JS and HTML ",
        tags:["JS","Html","Css"],
        
        demo:"https://gamzeumac.github.io/MusicApp/",
        github:"https://github.com/gamzeumac/MusicApp"
    }
  
  
] 